import React from 'react';
import { MapContainer, TileLayer, Marker, Circle, Popup } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Leaflet marker ikonkalari webpack bilan avtomatik topilmaydi —
// ularni to'g'ridan-to'g'ri ko'rsatamiz, aks holda marker ko'rinmaydi.
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';
import { tr } from '../til';

L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow
});

/// Xodimning joylashuvi va uning ish zonasini bitta xaritada ko'rsatadi.
///
/// Zona doirasi chizilgani uchun "497 m uzoqda" degan raqam ko'z bilan
/// tushunarli bo'ladi — xodim doiradan qanchalik chetda turgani ko'rinadi.
function LocationMap({
  latitude, longitude, accuracy,
  zoneLatitude, zoneLongitude, zoneRadius, zoneName,
  personName
}) {
  const hasPerson = latitude != null && longitude != null;
  const hasZone = zoneLatitude != null && zoneLongitude != null;

  if (!hasPerson && !hasZone) {
    return (
      <div style={{
        height: '360px', display: 'flex', alignItems: 'center',
        justifyContent: 'center', background: '#f5f5f5',
        borderRadius: '10px', color: '#999', fontSize: '14px'
      }}>
        {tr("Joylashuv ma'lumoti yo'q")}
      </div>
    );
  }

  // Ikkalasi ham bo'lsa o'rtasiga qaratamiz, aks holda mavjudiga.
  const center = hasPerson && hasZone
    ? [(Number(latitude) + Number(zoneLatitude)) / 2,
       (Number(longitude) + Number(zoneLongitude)) / 2]
    : hasPerson
      ? [Number(latitude), Number(longitude)]
      : [Number(zoneLatitude), Number(zoneLongitude)];

  // Ikki nuqta uzoq bo'lsa uzoqroqdan ko'rsatamiz.
  let zoom = 16;
  if (hasPerson && hasZone) {
    const dLat = Math.abs(Number(latitude) - Number(zoneLatitude));
    const dLng = Math.abs(Number(longitude) - Number(zoneLongitude));
    const spread = Math.max(dLat, dLng);
    if (spread > 0.2) zoom = 9;
    else if (spread > 0.05) zoom = 11;
    else if (spread > 0.01) zoom = 13;
    else if (spread > 0.003) zoom = 15;
  }

  return (
    <MapContainer
      center={center}
      zoom={zoom}
      style={{ height: '360px', width: '100%', borderRadius: '10px' }}
      scrollWheelZoom
    >
      <TileLayer
        attribution='&copy; OpenStreetMap'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />

      {hasZone && (
        <Circle
          center={[Number(zoneLatitude), Number(zoneLongitude)]}
          radius={Number(zoneRadius) || 200}
          pathOptions={{ color: '#2d8a2d', fillColor: '#2d8a2d', fillOpacity: 0.15 }}
        >
          <Popup>
            <strong>{zoneName || tr("Ish zonasi")}</strong>
            <br />
            {tr("Radius: {zoneRadius} m", { zoneRadius })}
          </Popup>
        </Circle>
      )}

      {hasPerson && (
        <>
          <Marker position={[Number(latitude), Number(longitude)]}>
            <Popup>
              <strong>{personName || tr("Xodim")}</strong>
              <br />
              {Number(latitude).toFixed(6)}, {Number(longitude).toFixed(6)}
              {accuracy != null && <><br />{tr("Aniqlik: ±{round} m", { round: Math.round(accuracy) })}</>}
            </Popup>
          </Marker>

          {/* GPS aniqligi doirasi — nuqta qanchalik ishonchli ekanini ko'rsatadi */}
          {accuracy != null && (
            <Circle
              center={[Number(latitude), Number(longitude)]}
              radius={Number(accuracy)}
              pathOptions={{ color: '#4f8ef7', fillColor: '#4f8ef7', fillOpacity: 0.1, weight: 1 }}
            />
          )}
        </>
      )}
    </MapContainer>
  );
}

export default LocationMap;
